/**
 * KATALOGEN: alle eksportene i Tvitvi, samlet fra én fil per område.
 *
 * En ny eksport er en ny post i områdets fil her, og en ny definisjon med samme `id` i
 * `apps/api/src/export/definitions/<område>/`. Ingenting annet (oppskriften står i docs/EKSPORT.md).
 */
import { AGENCY_EXPORTS } from './catalogue/agency.js';
import { AGENCY_TOUR_EXPORTS } from './catalogue/agency-tour.js';
import { ARTIST_EXPORTS } from './catalogue/artist.js';
import { BOOKING_EXPORTS } from './catalogue/booking.js';
import { COMMON_EXPORTS } from './catalogue/common.js';
import { CONCERTS_EXPORTS } from './catalogue/concerts.js';
import { CONTROL_ROOM_EXPORTS } from './catalogue/control-room.js';
import { FESTIVAL_EXPORTS } from './catalogue/festival.js';
import { FESTIVAL_CROSS_EXPORTS } from './catalogue/festival-cross.js';
import { FESTIVAL_OPERATIONS_EXPORTS } from './catalogue/festival-operations.js';
import { FESTIVAL_PEOPLE_EXPORTS } from './catalogue/festival-people.js';
import { FESTIVAL_PROGRAM_EXPORTS } from './catalogue/festival-program.js';
import { SETTINGS_EXPORTS } from './catalogue/settings.js';
import { VENUE_EXPORTS } from './catalogue/venue.js';
import type { ExportMeta } from './types.js';

export const EXPORT_CATALOGUE: readonly ExportMeta[] = [
  ...FESTIVAL_EXPORTS,
  ...FESTIVAL_PROGRAM_EXPORTS,
  ...FESTIVAL_CROSS_EXPORTS,
  ...FESTIVAL_PEOPLE_EXPORTS,
  ...FESTIVAL_OPERATIONS_EXPORTS,
  ...BOOKING_EXPORTS,
  ...AGENCY_EXPORTS,
  ...AGENCY_TOUR_EXPORTS,
  ...VENUE_EXPORTS,
  ...CONCERTS_EXPORTS,
  ...COMMON_EXPORTS,
  ...SETTINGS_EXPORTS,
  ...CONTROL_ROOM_EXPORTS,
  ...ARTIST_EXPORTS,
];

const BY_ID: ReadonlyMap<string, ExportMeta> = new Map(EXPORT_CATALOGUE.map((meta) => [meta.id, meta]));

export function exportMeta(id: string): ExportMeta | undefined {
  return BY_ID.get(id);
}
